import { AxiosAdapter } from '../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';

export class Service {
	async getData({ status, page, pharmacy, delivery_type, trx_id }) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.PANEL_TRACKING}/search/v2/find-by-status/country/${Enviroment.LANGUAGE}/status/${status}/page/${page}`,
			params: { pharmacy: pharmacy, delivery_type, trx_id: trx_id },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

	async getDataById(trx_id, pharmacy) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.PANEL_TRACKING}/pharmacy-standard/v2/country/${Enviroment.LANGUAGE}/pharmacy/${pharmacy}/trx_id/${trx_id}/one-record`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async getDataByTrxId(order_id) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.PANEL_TRACKING}/search/v2/order-id/${order_id}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}
	async getPharmacies() {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FRONT_COMMON}/pharmacies/${Enviroment.LANGUAGE}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
